export default {
  addSupplierDelivery: {
    detail: {
      save: '保存',
      submiLogistics: '提交物流',
      applayTransfer: '申请运输',
      createBusinessRepository: '生成业务入库单',
      withdraw: '撤回',
      delte: '删除',
      upload: '上传运输附件',
      shippingInstruction: '发货指令编号',
      createData: '创建日期',
      instructionStatus: '发货指令状态',
      createPersonName: '制单人',
      companyName: '公司',
      instructionType: '发货指令类型',
      isDirectDeliver: '是否直拨',
      deliverMethod: '发货方式',
      partnerNo: '供应商',
      customerName: '客户',
      departmentNo: '部门',
      salesmanNo: '业务员',
      deliverFromAddress: '发货详情地址',
      deliverToStorageNo: '收货仓库',
      deliverFromStorageNo: '发货仓库',
      purchaseContractNo: '采购合同号',
      purchaseIntentNo: '意向单号',
      deliverDate: '发货日期',
      expectArrivalDate: '预计到货日期',
      chooseExpectArrivalDate: '预计到货日期',
      flowDirection: '流向',
      registrationNo: '进境备案清单号',
      insured: '是否投保',
      externalContractNo: '外部合同号',
      shippingContact: '发货联系方式',
      shippingContactPerson: '发货联系人',
      businessMode: '业务性质', //经营方式
      distributionMode: '运输方式',
      baseInfo: '基本信息',
      shoppingInfo: '商品信息（行项目）',
      indexNum: '序号',
      purchaseContractDetailNo: '采购合同行项目号',
      purchaseIntentDetailNo: '意向单行项目号',
      productNo: '商品编码',
      productDesc: '商品描述',
      contractNo: '签约数量',
      instructionAbleNumber: '供应商可发货指令数量',
      instructionNumber: '供应商发货指令数量',
      overShippedPercentage: '溢装比例',
      unit: '单位',
      packaging: '包装',
      unitWeight: '单位重量',
      unitNumber: '件数',
      packagingNumber: '包装数量',
      packagingUnit: '包装单位',
      storageNo: '仓库',
      mark: '备注',
      contractUnitPrice: '合同单价',
      totalAmount: '金额',
      contractUnitPriceHN: '采购单价',
      shippingUnitExpenseHN: '运费单价',
      totalAmountHN: '采购金额',
      salesContractUnitPrice: '销售单价',
      salesShippingUnitExpense: '销售运费单价',
      salesContractTotalAmount: '销售金额',
      distributionNo: '物流流水编码',
      transportInfo: '运输信息',
      insuredOptionOne: '投保',
      insuredOptionTwo: '非投保',
      topTitle: '供应商发货指令',
      vesselName: '船名/航次/车牌',
      freightInformation: '货运信息',
      contactPerson: '联系人',
      contactPhoneNo: '联系方式',
      identityCardNumber: '身份证',
      instructionStatusOptOne: '已保存',
      instructionStatusOptTwo: '已确认',
      instructionStatusOptThree: '已执行',
      instructionStatusOptFour: '已撤销',
      download: '下载运输附件',
      marineLadingNo: '海运提单号',
      warehouseReceiptsNo: '期货仓单号',
      addShippingInformation: '请添加运输信息',
      transportPrint: '运输格式打印',
    },
    upload: {
      title: '打印及附件',
      cancel: '取消',
      save: '确定',
      topTitle: '上传附件',
      indexNum: '序号',
      fileName: '附件名称',
      fileType: '类型',
      uploadTime: '上传时间',
      uploadPerson: '上传人',
      uploadOperation: '操作',
      del: '删除',
      downTitle: '下载附件',
      download: '下载',
      mark: '名称',
      markPlaceholder: '请输入200字以内的任务描述',
      selectFile: '选择文件',
      saveData: '保存',
    },
    option: {
      save: '已保存',
      sure: '已确认',
      toStore: '已业务入库',
      cancel: '已撤销',

      direct: '直拨',
      notDirect: '非直拨',

      supplierSend: '供应商配送',
      selfProduction: '物产自提',
      selfCustomer: '客户自提',
      libraryTurn: '库转',
    },
    rules: {
      flowDirectionMessage: '请选择流向或收货仓库',
      noInstructionNumber: '剩余可发数量不足，请检查',
    },
  },
};
